import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=cb22dbaa&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=cb22dbaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb22dbaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb22dbaa')) {
      api.createRecord('cb22dbaa', component.options)
    } else {
      api.reload('cb22dbaa', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=cb22dbaa&scoped=true&", function () {
      api.rerender('cb22dbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bDCRZHq716kA/JS/comp/Voucher.vue"
export default component.exports